import React from "react";
import { Table, P, Button } from "../../ui";

export default function MarkersTableView({
  showButtons,
  data,
  loading,
  handleModalOpen
}) {
  let columns = [
    {
      title: "",
      className: "id",
      render: ({ i }) => 1 + i
    },
    {
      title: "Маркер",
      render: ({ item }) => {
        return (
          <P size="small" upper={true} strong={true} margin="no">
            %{item.text_name}%
          </P>
        );
      }
    },
    {
      title: "Описание",
      render: ({ item }) => {
        return item.text_description;
      }
    }
  ];

  if (showButtons) {
    columns.push({
      title: "-",
      render: ({ item }) => {
        return (
          <Button
            type="button"
            theme="default"
            size="s"
            name={`${item._id}:edit`}
            onClick={e => handleModalOpen(e, "edit", item._id)}
          >
            Изменить
          </Button>
        );
      }
    });

    columns.push({
      title: "-",
      render: ({ item }) => {
        return (
          <Button
            type="button"
            theme="error"
            size="s"
            name={`${item._id}:delete`}
            onClick={e => handleModalOpen(e, "delete", item._id)}
          >
            Удалить
          </Button>
        );
      }
    });
  }

  return <Table columns={columns} data={data} loading={loading} />;
}
